import { LoggerError } from './LoggerError'

/**
 * 日志警告，仅用于日志记录
 */
export abstract class LoggerWarning extends LoggerError {}
